// extracted by mini-css-extract-plugin
export default {"contractor":"styles_contractor__DKhFO","contractorTag":"styles_contractorTag__qE1IL"};